import React from 'react';

function Payments() {
    return <h2>Payments</h2>;
}

export default Payments;
